<template>
<div class="col-xl-6 col-lg-12">
    <div class="row">
        <div class="col-sm-6" v-for="(item,index) in menu" :key="index">
            <div class="card social-widget-card">
                <div class="card-body">
                    <div class="d-flex">
                        <div class="social-font"><img :src="item.img" alt=""></div>
                        <div class="flex-grow-1">
                            <h2>{{item.name}}</h2>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col text-center">
                            <h6 class="font-roboto">Posts</h6>
                            <h5 class="counter mb-0 font-roboto font-primary mt-1"><number calass="bold"
                                ref="number1"
                                :from="0"
                                :to="item.posts"
                                :duration="5"
                                :delay="0"
                                easing="Power1.easeOut" />
                            </h5>
                        </div>
                        <div class="col text-center">
                            <h6 class="font-roboto">Likes</h6>
                            <h5 class="counter mb-0 font-roboto font-primary mt-1"><number calass="bold"
                                ref="number1"
                                :from="0"
                                :to="item.likes"
                                :duration="5"
                                :delay="0"
                                easing="Power1.easeOut" /></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</div>
</template>

<script>
import {
    SocialData
} from '../../../data/widgets/general/data'
export default {
    name: 'socialPage',
    data() {
        return {
            menu: SocialData
        }
    }
}
</script>
